import { Button, Typography } from '@mui/material'
import React, { useState } from 'react'
import { InformationModal } from 'utoniq-ui'

import { BaseLayout, Head } from '@/components/layouts'
import { useMessage, useRouter, useTranslation } from '@/core'
import { Cell, CellFrame, Template } from '@/core/architecture'

import {
  PasswordResetSendForm,
  PasswordResetSendFormProps,
} from './PasswordResetSendForm'

export * from './fragments'

export type State = {}

export type Action = {
  onSubmitPasswordResetSend: PasswordResetSendFormProps['onSubmitPasswordResetSend']
}

export const PasswordResetSendTemplate: Template<State, Action> = ({
  state,
  onSubmitPasswordResetSend,
}) => {
  const { t } = useTranslation('passwordResetSend')
  const { routerNames, routerPages } = useRouter()
  const { showError } = useMessage()

  const [open, setOpen] = useState(false)

  const onSend: PasswordResetSendFormProps['onSubmitPasswordResetSend'] =
    inputs =>
      onSubmitPasswordResetSend(inputs)
        .then(() => setOpen(true))
        .catch(e => {
          showError(e)
        })

  return (
    <BaseLayout
      margin
      header={{
        title: t('title'),
        back: true,
        defaultBackPage: routerPages.Top,
      }}
    >
      <Head title={routerNames.PasswordResetSend} />
      <TextCell />
      <PasswordResetSendForm onSubmitPasswordResetSend={onSend} />
      <InformationModal
        open={open}
        onClose={() => setOpen(false)}
        title={t('completeMessage')}
        content=""
        buttons={
          <Button
            onClick={() => setOpen(false)}
            sx={{ width: 212 }}
            size="large"
          >
            OK
          </Button>
        }
      />
    </BaseLayout>
  )
}

const TextCell: Cell = () => {
  const { t } = useTranslation('passwordResetSend')

  return (
    <CellFrame sx={{ pt: 2, pb: 5 }}>
      <Typography variant="body2">{t('description')}</Typography>
    </CellFrame>
  )
}
